import type { FaireProductEntity } from "../../entity_types/product";

export const p_qwe2s4hrwg: FaireProductEntity = {
  token: "p_qwe2s4hrwg",
  type: "product",
  name: "Ceramic Flower Shaped Side Plate with Pink Border",
  brandToken: "b_c8yganb0qb",
  brandName: "RicebyRice",
  imageUrl:
    "https://cdn.faire.com/fastly/d5e3b7dbc0bb438da477e56543b1b691771fd46c4e4c645a9528014b246e42ad.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/04754622c7af0da7012d75160ad04ea2a89a1763d747fb926b321326a0d8aa7e.jpeg",
    "https://cdn.faire.com/fastly/666d808ed198920d33b160094b0fc0755facdd818ea0b428c514302c1851fe08.jpeg",
  ],
  priceDollars: 22.5,
  description:
    "In rice living we go a long way to making you feel home – in a home with a personal touch. This ceramic series is handmade and hand-painted by amazing women in Portugal.",
  tags: [],
  isBestseller: true,
  msrpDollars: 44.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-06T00:00:00.000Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
